import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './selection-cell.scss';

const SelectionCell = ({ children }) => <div className={classNames(styles.cell, styles.selectionCell)}>{children}</div>;

SelectionCell.propTypes = {
  children: PropTypes.node,
};

export default SelectionCell;
